export const CONIFG = {
    version: '1.0.31.10', // All Site version 
    policy_version: '1-2022.04.12',  // policy notice verion .. when policy or eula update, it should be updated

}